import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { TrackingScreenNamesEnum } from '../../../tracking/tracking.data';
import {
  I2gNgTrackingActionBuilder,
  ITrackingAction,
  ITrackingObject,
} from 'i2g-ng-tracking';
import { AlignmentEnum, IconSizesEnum, IIcon, IRouter } from 'i2g-ng-ui';
import { URLS } from 'i2g-ng-utils';

@Component({
  selector: 'app-global-header',
  templateUrl: 'global-header.component.html',
  styleUrls: ['global-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GlobalHeaderComponent implements OnInit {
  @Input() label: string;
  @Input() route: IRouter;
  @Input() trackingScreenName: TrackingScreenNamesEnum;
  @Input() trackingObject: ITrackingObject;

  AlignmentEnum: typeof AlignmentEnum;
  externalUrl: string;
  invoice2goUrl: string;
  invoice2goLogo: IIcon;
  logoTrackingAction: ITrackingAction;

  constructor(private _trackingActionBuilder: I2gNgTrackingActionBuilder) {}

  ngOnInit() {
    this.logoTrackingAction = this._trackingActionBuilder.buildButtonTapped(
      'invoice2go_logo',
      this.trackingScreenName
    );

    this.AlignmentEnum = AlignmentEnum;
    this.invoice2goUrl = URLS.INVOICE2GO;
    this.invoice2goLogo = {
      name: 'invoice2go-logo-white',
      size: IconSizesEnum.custom,
    };
    this.externalUrl =
      this.route &&
      this.route.external &&
      this.route.route &&
      this.route.route[0];
  }
}
